module.exports = {
  PRISMIC_BASE_URL: process.env.PRISMIC_BASE_URL || 'https://base10.cdn.prismic.io/api/v2',
  PRISMIC_ACCESS_TOKEN:
    process.env.PRISMIC_ACCESS_TOKEN ||
    'MC5YdUxxUEJBQUFDSUFZSHRY.Ku-_vS9Z77-977-977-9cWzvv705ai4AYe-_ve-_ve-_vQzvv71177-9SB1877-977-977-9e--_vQjvv70',
};
